import { render } from "./OverviewStaff.vue?vue&type=template&id=df330c74&scoped=true"
import script from "./OverviewStaff.vue?vue&type=script&lang=js"
export * from "./OverviewStaff.vue?vue&type=script&lang=js"

import "./OverviewStaff.vue?vue&type=style&index=0&id=df330c74&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df330c74"]])

export default __exports__